import Accordion from 'react-bootstrap/Accordion'
import { useEffect } from 'react'
import { NavDropdown } from 'react-bootstrap'

function DivBottom() {
    useEffect(() => {
        for (let x = 0; x < 2; x++) {
            document.getElementsByClassName('privacyPolicy')[x].innerHTML = '<a href="https://www.iubenda.com/privacy-policy/43060284" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy " style="text-decoration:none; color:white">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>'
            document.getElementsByClassName('cookiePolicy')[x].innerHTML = '<a href="https://www.iubenda.com/privacy-policy/43060284/cookie-policy" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Cookie Policy " style="text-decoration:none; color:white">Cookie Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>'
            document.getElementsByClassName('terminiCondizioni')[x].innerHTML = '<a href="https://www.iubenda.com/termini-e-condizioni/43060284" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Termini e Condizioni " style="text-decoration:none; color:white">Termini e Condizioni</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>'
        }
    }, [])
    return (<>
        {/* --------------- MOBILE -------------- */}
        <div className='accordionHomeMobile mt-5'>
            <Accordion defaultActiveKey="0" style={{ opacity: '0.9' }}>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>
                        Informazioni
                    </Accordion.Header>
                    <Accordion.Body>
                        Siamo nati in Ancona nel 2025 e il motivo del nostro lavoro è quello di offrire un servizio online degli eventi in Italia.
                        I contenuti vengono esaminati e controllati prima di essere divulgati online, per una maggiore sicurezza
                        verso chi usufruisce di questa piattaforma.
                        Per organizzare le vostre vacanze o il vostro weekend potete accedere alle informazioni del sito liberamente.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Legale</Accordion.Header>
                    <Accordion.Body>
                        <NavDropdown.Item href="https://www.iubenda.com/privacy-policy/43060284">
                            <p className='privacyPolicy' style={{ fontSize: 'small' }}></p>
                        </NavDropdown.Item>
                        <NavDropdown.Item href="https://www.iubenda.com/privacy-policy/43060284/cookie-policy">
                            <p className='cookiePolicy' style={{ fontSize: 'small' }}></p>
                        </NavDropdown.Item>
                        <NavDropdown.Item href="https://www.iubenda.com/termini-e-condizioni/43060284">
                            <p className='terminiCondizioni' style={{ fontSize: 'small' }}></p>
                        </NavDropdown.Item>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                    <Accordion.Header>Contatti</Accordion.Header>
                    <Accordion.Body>
                        www.zonaEventi.it di Borsini Leuro<br />
                        Ancona Via Russi n.16 60131 (AN)<br />
                        zonaeventiinfo@gmail.com
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                    <Accordion.Header>Responsabilità</Accordion.Header>
                    <Accordion.Body>
                    L'Utente risponde in via esclusiva degli eventi caricati, pubblicati, condivisi o comunque forniti a questa Applicazione. 
                    L'annullamento o la pubblicazione di eventi mendaci non giustificano alcuna pretesa di risarcimento, 
                    rimborso o indennizzo in capo agli Utenti che hanno fornito tali contenuti.
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
        {/* ---------------- DESKTOP -------------------- */}
        <div className="container-fluid accordionHomeDesktop mt-5"
            style={{
                backgroundColor: 'midnightblue',
                color: 'azure',
                padding: '15px',
                fontFamily: 'Verdana, Geneva, Tahoma, sans-serif',
                marginTop: '5rem',
                fontSize:'small'
            }}>
            <div className="row" style={{ opacity: '0.8' }}>
                <div className="col" style={{ margin: '2rem' }}>
                    <h5 style={{ opacity: '0.8' }}>Informazioni</h5>
                    <p className='mt-3'>
                        Siamo nati in Ancona nel 2025 e il motivo del nostro lavoro è quello di offrire un servizio online degli eventi in Italia.
                        I contenuti vengono esaminati e controllati prima di essere divulgati online, per una maggiore sicurezza
                        verso chi usufruisce di questa piattaforma.
                        Per organizzare le vostre vacanze o il vostro weekend potete accedere alle informazioni del sito liberamente.
                    </p>
                </div>
                <div className="col" style={{ margin: '2rem' }}>
                    <h5 style={{ opacity: '0.8' }}>Legale</h5>
                    <div className='mt-3'>
                        <p className='privacyPolicy' />
                        <p className='cookiePolicy' />
                        <p className='terminiCondizioni' />
                    </div>
                </div>
                <div className="col" style={{ margin: '2rem' }}>
                    <h5 style={{ opacity: '0.8' }}>Contatti</h5>
                    <p className='mt-3'>
                        www.zonaEventi.it di Borsini Leuro<br />
                        Ancona Via Russi n.16 60131 (AN)<br />
                        email: zonaeventiinfo@gmail.com
                    </p>
                </div>
                <div className="col" style={{ margin: '2rem' }}>
                    <h5 style={{ opacity: '0.8' }}>Responsabilità</h5>
                    <p className='mt-3'>
                    L'Utente risponde in via esclusiva degli eventi caricati, pubblicati, condivisi o comunque forniti a questa Applicazione. 
                    L'annullamento o la pubblicazione di eventi mendaci non giustificano alcuna pretesa di risarcimento, 
                    rimborso o indennizzo in capo agli Utenti che hanno fornito tali contenuti.
                    </p>
                </div>
            </div>
        </div>
    </>)
}
export default DivBottom